<template>
    <div class="Com_1231">
      <title1 type="2" title="月季度考核指标">
        <template v-slot:tab>
          <div class="title-3"></div>
        </template>
      </title1>
      <div class="bottom">
          <div class="left">
						<!--<img class="photovoltaicImg" src="https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/65575ba55a7e3f0310d49b8e/6584f740fcfbac00113ab77e/0478580df48bac7d1dfc7a330aece297.png" alt="">-->
	          <div class="circle-1">
		          <div class="circle-2">
			          <div class="circle-3"></div>
		          </div>
	          </div>
          </div>
          <div class="right">
            <div class="rightBox">
              <div class="box_1">
                <div class="row_2">
									<!--<div class="iconName"><span class="name">月完成率</span></div>
	                <span class="number">{{infoObj.ywcl}}%</span>-->
	                <div style="width:100%">
		                <div
			                :style="{
												display: 'flex',
												flexDirection: 'row',
												alignItems: 'center',
												justifyContent: 'space-between'
											}"
		                >
			                <div
				                :style="{
													lineHeight: '26px',
													fontSize: '18px',
													fontWeight: 400
												}"
			                >
				                月完成率
			                </div>
			                <div
			                  :style="{
													fontSize: '20px',
													lineHeight: '28px',
													fontFamily: 'Eurostile LT Std',
													color: 'rgba(255,255,255,0.9)',
													fontWeight: 'normal'
												}"
			                >
				                {{format(infoObj.ywcl)}}%
			                </div>
		                </div>

		                <div style="margin-top: 16px;position: relative;">
			                <div style="position:absolute;left:0;top:0;width: 220px; height: 2px; background: rgba(255,255,255,0.06); border-radius: 0px 0px 0px 0px; opacity: 1;"></div>
			                <div style="position:absolute;left:0;top:0;width: 159px; height: 2px; background: linear-gradient(270deg, #FFFFFF 0%, rgba(255,255,255,0) 100%); border-radius: 0px 0px 0px 0px; opacity: 1;"></div>
		                </div>
	                </div>
                </div>
                <div class="row_2">
                  <div class="iconName"><div class="icon icon1"></div><span class="name">计划发电量</span></div>
                  <span class="number">{{infoObj.jhfdl}}</span>
                </div>
                <div class="row_2">
                  <div class="iconName"><div class="icon icon2"></div><span class="name">实际发电量</span></div>
                  <span class="number">{{infoObj.sjfdl}}</span>
                </div>
								<div class="row_2">
								  <div class="iconName"><div class="icon icon3"></div><span class="name">上网电量</span></div>
								  <span class="number">{{infoObj.swdl}}</span>
								</div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </template>
  
  <script>
  import title1 from "@/views/exposition/components/title3";
  import { dataInterface } from "@/api/dataInterfaceApi";
  export default {
    components: {
      title1,
    },
    data() {
      return {
        infoObj: {}
      };
    },
    methods: {
      serverOverview() {
        let params1 = {
          "enCode": "zngf-dz-yuekaohezhibiao",// 接口code
           "@station_id": localStorage.getItem('guangfuStationId') ? localStorage.getItem('guangfuStationId') : "320500H001" // 接口传参
        };
        dataInterface
          .dataFaceApi(params1)
          .then((res) => {
            console.log(res, "站点信息");
             if(res) {
				 this.infoObj = res[0]
			 }
          })
          .catch((err) => {
            console.log(err);
          });
      },
	    format(item){
		    if(item)return item.split('.')[0];
		    return item;
	    },
    },
    destroyed() {
      // this.$bus.$off('onfangdiangonglv')
    },
    mounted() {
      this.serverOverview();
    },
  };
  </script>
  
  <style lang="scss" scoped>
  @import "@/views/components/energyStorage/comm.scss";
  
  .Com_1231 {
    .title-3{
        width: 35%;
        height: 90%;
        background: url(~@/assets/images/myComm/title-3-3.png) left bottom no-repeat;
        background-size: 100% 54px; 
        float: right;
    }
    .bottom {
      height: 410px;
      width: 565px;
      // background: red;
      display: flex;
      .left{
        width: 345px;
        height: 410px;
        display: flex;
        align-items: center;

	      .circle-1 {
		      position: relative;
		      width: 225px;
		      height: 225px;
		      background: rgba(117,181,226,0.1);
		      border-radius: 50%;
		      border: 4px solid #75B5E2;

		      .circle-2 {
			      position: absolute;
			      bottom:-4px;
			      left: 50%;
			      transform: translateX(-50%);

			      width: 171px;
			      height: 171px;
			      background: rgba(243,214,142,0.1);
			      border-radius: 50%;
			      border: 4px solid #F3D68E;

			      .circle-3 {
				      position: absolute;
				      bottom:-4px;
				      left: 50%;
				      transform: translateX(-50%);

				      width: 104px;
				      height: 104px;
				      background: rgba(81,219,219,0.1);
				      border-radius: 50%;
				      border: 4px solid #11E5D8;
			      }
		      }
	      }
	      /*.photovoltaicImg{
          width: 200px;
		      margin-left: 38px;
          // height: 100%;
        }*/
      }
      .right{
        flex: 1;
        // background: red;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .rightBox{
          width: 220px;
          height: 246px;
          // background: skyblue;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
		  margin-top: 45px;
          .box_1{
            width: 220px;
            height: 176px;
            // background: orange;
			.name-title{
				font-size: 20px;
				font-weight: 600;
				color: #ffffff;
			}
            .row_1,.row_2{
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            .row_1{
              color: rgba(255, 255, 255, 0.90);
              .name{
                font-size: 18px;
              }
              .number{
                font-size: 24px;
              }
            }
            .row_2{
              margin-top: 15px;
              color: rgba(255, 255, 255, 0.70);
			  .iconName{
				  display: flex;
				  .icon{
					  width: 16px;
					  height: 16px;
					  background-color: yellow;
					  margin-right: 5px;
					  margin-top: 3px;
				  }
				  .icon1{
					  background-color: rgba(117, 181, 226, 1);
				  }
				  .icon2{
				  	background-color: rgba(243, 214, 142, 1);
				  }
				  .icon3{
				  	background-color: rgba(26, 239, 239, 1);
				  }
			  }
			  .number{
				  font-size: 18px;
				  font-weight: 600;
			  }
            }
          }
          .box_2{
            width: 220px;
            height: 54px;
            // background: pink;
            .row_3{
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: space-between;
              color: rgba(255, 255, 255, 0.90);
              .name{
                font-size: 18px;
              }
                .number{
                  font-size: 24px;
                }
            }
          }
        }
      }
      .num {
        padding-left: 10px;
        font-size: 24px;
        font-family: "HT";
        color: #00ffff;
      }
      .text{
          letter-spacing: 3px;
          font-family: 'PMZD';
        }
    }
  }
  
  </style>